<script>
  import Section from "$lib/components/Section.svelte";
  import SplitLayoutComponent from "$lib/contentTypes/SplitLayoutComponent.svelte";

  export let speakers = [];
  export let title = undefined;

  $: data = {
    fields: {
      formFactor: "50/50",
      itemsLeft: [
        {
          fields: {
            richTextContent: {
              nodeType: "heading-4",
              data: {
                target: {}
              },
              content: [
                {
                  value: title || "Speakers"
                }
              ]
            }
          },
          sys: {
            contentType: {
              sys: {
                id: "freeRichTextComponent"
              }
            }
          }
        }
      ],
      itemsRight: [
        {
          fields: {
            items: speakers.map((speaker) => {
              let contentArray = [
                {
                  data: {},
                  nodeType: "text",
                  value: speaker.fields.blurb
                },
                {
                  nodeType: "text",
                  value: "\n\n"
                }
              ];
              if (speaker.fields.url?.length > 0) {
                contentArray.push({
                  nodeType: "embedded-entry-block",
                  data: {
                    target: {
                      fields: {
                        destination: {
                          fields: {
                            url: speaker.fields.url
                          }
                        },
                        text: "Learn More",
                        type: "smallTextLink"
                      },
                      sys: {
                        contentType: {
                          sys: {
                            id: "linkComponent"
                          }
                        }
                      }
                    }
                  },
                  content: [
                    {
                      value: "Learn More"
                    }
                  ]
                });
              }
              return {
                fields: {
                  headline: speaker.fields.name,
                  body: {
                    nodeType: "paragraph",
                    content: contentArray,
                    data: {}
                  },
                  image: {
                    fields: {
                      imageAsset: {
                        fields: {
                          alt: speaker.fields.altText,
                          file: {
                            url: speaker.fields.image?.fields.file?.url
                          }
                        }
                      }
                    }
                  }
                },
                sys: {
                  contentType: {
                    sys: {
                      id: "contentGroupItem"
                    }
                  }
                }
              };
            }),
            formFactor: "List: Thumbnail"
          },
          sys: {
            contentType: {
              sys: {
                id: "contentGroup"
              }
            }
          }
        }
      ]
    }
  };
</script>

<Section class="event-speakers pb-25 md:pb-30 lg:pb-25 xl:pb-50">
  <SplitLayoutComponent {data} />
</Section>
